const DB_NAME = 'SIBI_pos_offline';
const DB_VERSION = 3;

const STORES = {
    categories: 'categories',
    menuItems: 'menuItems',
    sections: 'sections',
    customers: 'customers',
    cart: 'cart',
    pendingCustomers: 'pendingCustomers',
    pendingOrders: 'pendingOrders',
};

function openDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;

            if (!db.objectStoreNames.contains(STORES.categories)) {
                db.createObjectStore(STORES.categories, { keyPath: 'id' });
            }
            if (!db.objectStoreNames.contains(STORES.menuItems)) {
                const dishStore = db.createObjectStore(STORES.menuItems, { keyPath: 'id' });
                dishStore.createIndex('category_id', 'category_id', { unique: false });
            }
            if (!db.objectStoreNames.contains(STORES.sections)) {
                db.createObjectStore(STORES.sections, { keyPath: 'id' });
            }
            if (!db.objectStoreNames.contains(STORES.customers)) {
                db.createObjectStore(STORES.customers, { keyPath: 'id' });
            }
            if (!db.objectStoreNames.contains(STORES.cart)) {
                db.createObjectStore(STORES.cart, { keyPath: 'idx' });
            }
            if (!db.objectStoreNames.contains(STORES.pendingOrders)) {
                db.createObjectStore(STORES.pendingOrders, { keyPath: 'offline_id' });
            }
            if (!db.objectStoreNames.contains(STORES.pendingCustomers)) {
                const pendingStore = db.createObjectStore(STORES.pendingCustomers, { keyPath: 'offline_id' });
                pendingStore.createIndex('action', 'action', { unique: false });
            }
        };

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

async function getAll(storeName) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, 'readonly');
        const store = tx.objectStore(storeName);
        const request = store.getAll();
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

async function getByIndex(storeName, indexName, value) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, 'readonly');
        const store = tx.objectStore(storeName);
        const index = store.index(indexName);
        const request = index.getAll(value);
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

async function put(storeName, data) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, 'readwrite');
        const store = tx.objectStore(storeName);
        store.put(data);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
}

async function putAll(storeName, items) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, 'readwrite');
        const store = tx.objectStore(storeName);
        items.forEach((item) => store.put(item));
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
}

async function remove(storeName, key) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, 'readwrite');
        const store = tx.objectStore(storeName);
        store.delete(key);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
}

async function clearStore(storeName) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, 'readwrite');
        const store = tx.objectStore(storeName);
        store.clear();
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
}

export {
    STORES,
    openDB,
    getAll,
    getByIndex,
    put,
    putAll,
    remove,
    clearStore,
};